export const removeExtension = (name: string) => {
    const dotPosition = name.indexOf(".");
    if (dotPosition === -1) {
        return name;
    }

    return name.substr(0, dotPosition);
};

